import { render } from "./SystemConfig.vue?vue&type=template&id=7075b692&scoped=true&ts=true"
import script from "./SystemConfig.vue?vue&type=script&lang=ts"
export * from "./SystemConfig.vue?vue&type=script&lang=ts"

import "./SystemConfig.vue?vue&type=style&index=0&id=7075b692&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7075b692"]])

export default __exports__